<template>
  <router-link
    class="navigator-to-zcar-index"
    :to="{
      name: category === 'premium' ? 'Index' : 'StandardDiscount'
    }">
    <div class="text">更多</div>
    <div class="text">自营车</div>
  </router-link>
</template>

<script setup>
import {computed} from 'vue'
import {useRoute} from 'vue-router'
import {useStore} from 'vuex'

const store = useStore()
const route = useRoute()

const category = computed(() => {
  return store.getters['Car/categoryByCarId'](route.params.id)
})

defineOptions({
  name: 'NavigatorToZCarIndex',
})
</script>

<style lang="scss" scoped>
.navigator-to-zcar-index {
  box-shadow: 0px 0px 19px 0px var(--zcar-primary);
  background: var(--zcar-primary);
  color: var(--white);
  position: fixed;
  bottom: 120px;
  right: 15px;
  font-size: .7rem;
  color: #ffffff;
  line-height: 1;
  z-index: 200;
  text-align: center;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  display: flex;
  flex-flow: column nowrap;

  &:hover {
    cursor: pointer;
    filter: brightness(.9);
  }

  > div {
    width: 100%;
    line-height: 1.425;
  }
}

</style>
